module.exports = __webpack_public_path__ + "static/img/eureka_icon_9.97b7f57c.png";